/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import CallIcon from "src/assets/images/settings/callicon.png";
// import { useLazyQuery } from "@apollo/client";
// import GetProductFeatures from "src/graphql/query/productandpricing/getProductFeatures";
import CheckIcon from "@mui/icons-material/Check";
import { PopupButton } from "react-calendly";
// import { enqueueSnackbar } from "notistack";
import useActiveUserDetail from "src/utils/shared/useActiveUserDetail";
import expressConfig from "src/config/express.json";
import { IPlan, IPrices } from "../dataTypes";
import useStyles from "./Styles";

interface IProps {
  keyIndex: number;
  handleOnClick: any;
  plan: string;
  // packageDetailsLoader: boolean;
  // setting?: boolean;
}

type IInterface = IProps & IPlan;

const Index: React.FC<IInterface> = ({
  keyIndex,
  name,
  description,
  prices,
  features,
  handleOnClick,
  plan,
  // packageDetailsLoader,
  // setting = false,
}) => {
  const { classes } = useStyles();

  const env = process.env.NODE_ENV || "development";
  const config = (expressConfig as any)[env];

  const [rootElement, setRootElement] = useState<HTMLElement | null>(null);

  // ✅ Only set rootElement on client side (to avoid SSR issues)
  useEffect(() => {
    if (typeof document !== "undefined") {
      setRootElement(document.getElementById("root") || document.body);
    }
  }, []);

  const { plans } = useActiveUserDetail();

  // const [productFeaturesList, setProductFeaturesList] = useState<IFeatures[]>(
  //   [],
  // );

  // const [
  //   getProductFeatures,
  //   {
  //     loading: getProductFeaturesQueryLoading,
  //     error: getProductFeaturesQueryError,
  //     data: getProductFeaturesQueryResult,
  //   },
  // ] = useLazyQuery(GetProductFeatures, { fetchPolicy: "network-only" });

  // useEffect(() => {
  //   if (!packageDetailsLoader && name) {
  //     getProductFeatures();
  //   }
  // }, [packageDetailsLoader]);

  // useEffect(() => {
  //   if (getProductFeaturesQueryResult?.getProductFeatures) {
  //     try {
  //       const productFeatures =
  //         typeof JSON.parse(
  //           getProductFeaturesQueryResult.getProductFeatures,
  //         ) === "string"
  //           ? JSON.parse(
  //               JSON.parse(getProductFeaturesQueryResult.getProductFeatures),
  //             )
  //           : JSON.parse(getProductFeaturesQueryResult.getProductFeatures);

  //       setProductFeaturesList(productFeatures);
  //     } catch (err) {
  //       enqueueSnackbar("Error parsing product features data", {
  //         variant: "error",
  //       });
  //     }
  //   }
  // }, [getProductFeaturesQueryResult]);

  // useEffect(() => {
  //   if (getProductFeaturesQueryError) {
  //     enqueueSnackbar(getProductFeaturesQueryError.message, {
  //       variant: "error",
  //     });
  //   }
  // }, [getProductFeaturesQueryError]);

  const getPricesAccordingToPlan = (pricesList: IPrices[]) => {
    const currentPlan = plan === "annual" ? "year" : "month";
    if (currentPlan === "month") {
      const montlyPrice = pricesList.find((item) => item.interval === "month");

      if (montlyPrice) {
        return Math.ceil(montlyPrice.price / 100);
      }
    }

    const annualPrice = pricesList.find(
      (item) => item.interval === "year" && item.intervalCount === 1,
    );

    if (annualPrice) {
      return Math.ceil(annualPrice.price / 100 / 12);
    }
    return null;
  };

  // const slicedProductFeaturesList = setting
  //   ? productFeaturesList.slice(0, 4)
  //   : productFeaturesList;

  const getPackageMarketing = (packageName: string) => {
    if (packageName === "standard")
      return (
        <Typography className={classes.package_container_plan}>
          Popular
        </Typography>
      );
    if (packageName === "business")
      return (
        <Typography className={classes.package_container_plan}>
          {/* Recommended */}
        </Typography>
      );
    return null;
  };

  return (
    <Box key={keyIndex} className={classes.package_container}>
      <Box className={classes.package_container_header_container}>
        <Typography className={classes.package_container_name}>
          {name}
        </Typography>
        {getPackageMarketing(name.toLowerCase())}
      </Box>
      <Typography className={classes.package_container_description}>
        {description}
      </Typography>
      {name.toLowerCase() === "enterprise" ? (
        <Box className={classes.enterprisePackage}>
          <img
            src={CallIcon}
            alt="Enterprise call icon"
            className={classes.enterpriseIcon}
          />
          <Typography className={classes.perUserText}>Tailored Plan</Typography>
        </Box>
      ) : (
        <Box className={classes.package_container_pricing_container}>
          <Box className={classes.package_container_pricing_figure}>
            <span className={classes.package_container_pricing_figure_dollar}>
              $
            </span>
            {getPricesAccordingToPlan(prices)}
          </Box>
          <Typography className={classes.perUserText}>
            Per user and per month
          </Typography>
        </Box>
      )}
      {name.toLowerCase() === "enterprise" ? (
        rootElement && (
          <PopupButton
            url={config.CALENDLY_URL}
            rootElement={rootElement}
            text="Request a Call"
            className={`${classes.package_container_btn}`}
          />
        )
      ) : (
        <Button
          onClick={handleOnClick}
          className={`${classes.package_container_btn} ${
            plans === "freetrial"
              ? ""
              : name.toLowerCase() === plans?.toLowerCase() &&
                classes.package_container_btn_active
          }`}
        >
          {/* {plans === "freetrial"
            ? "Subscribe Now"
            : name.toLowerCase() === plans?.toLowerCase()
            ? "Upgrade Current Plan"
            : "Switch to this Plan"}{" "} */}
          {plans === "freetrial"
            ? "Subscribe Now"
            : name.toLowerCase() === plans?.toLowerCase()
            ? "Upgrade"
            : "Switch"}{" "}
        </Button>
      )}
      <Box className={classes.package_container_features}>
        <Typography className={classes.featuresHeadText}>Features:</Typography>
        {features &&
          features.map((item) => (
            <Box className={classes.package_container_features_text}>
              <CheckIcon className={classes.package_container_features_icon} />
              <Typography>{item}</Typography>
            </Box>
          ))}
        {/* {getProductFeaturesQueryLoading ? (
          <Box className={classes.progressIndicator}>
            <CircularProgress color="primary" size={20} />
          </Box>
        ) : (
          slicedProductFeaturesList.map((categoryItem) =>
            categoryItem.features.slice(0, 2).map((feature) => (
              <Box className={classes.package_container_features_text}>
                <CheckIcon
                  className={classes.package_container_features_icon}
                />
                {Object.entries(feature.allowed).map(([key, value]) => (
                  <Typography key={key}>
                    {key.toLowerCase() === name.toLowerCase() && !!value
                      ? feature.name
                      : null}
                  </Typography>
                ))}
              </Box>
            )),
          )
        )} */}
      </Box>
    </Box>
  );
};

export default Index;
